import { render, staticRenderFns } from "./category-list-element.vue?vue&type=template&id=7b32591a&scoped=true"
import script from "./category-list-element.vue?vue&type=script&lang=js"
export * from "./category-list-element.vue?vue&type=script&lang=js"
import style0 from "./category-list-element.vue?vue&type=style&index=0&id=7b32591a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32591a",
  null
  
)

export default component.exports